export default "/images/tick.svg?caae6dfd708534f20afb297ae1fefce0";